import React from 'react';
import PropTypes from 'prop-types';
import { Result } from 'antd';
import FormError from './FormError';


const propTypes = {
    hasError: PropTypes.bool,
};

const defaultProps = {
    hasError: false,
};

const FormComplete = ({ hasError }) => {
    if (hasError) {
        return <FormError />;
    }

    return (
        <Result
            status="success"
            title="Booking Successful!"
            subTitle="You will receive a confirmation email shortly confirming your request."
        />
    );
};

FormComplete.propTypes = propTypes;
FormComplete.defaultProps = defaultProps;

export default FormComplete;
